// extracted by mini-css-extract-plugin
module.exports = {"ui_data_table":"UiDataTable_ui_data_table__3x6pY"};